import { twMerge } from 'tailwind-merge';

type ClassDictionary = Record<string, boolean | number | string | null | undefined>;
type ClassArray = ClassValue[];
type ClassValue = string | number | ClassDictionary | ClassArray | null | undefined | boolean;

const toClassString = (value: ClassValue): string => {
	if (!value) return '';
	if (typeof value === 'string' || typeof value === 'number') return String(value);
	if (Array.isArray(value)) return value.map(toClassString).filter(Boolean).join(' ');
	if (typeof value === 'object') {
		return Object.entries(value)
			.filter(([, v]) => Boolean(v))
			.map(([key]) => key)
			.join(' ');
	}
	return '';
};

/** Merge className strings/arrays/objects with Tailwind conflict resolution. */
export const classMerge = (...inputs: ClassValue[]) => twMerge(inputs.map(toClassString).filter(Boolean).join(' '));

const GRID_PLACEMENT_CLASS = /^(?:[\w-]+:)*(?:col-span|col-start|col-end|row-span|row-start|row-end)-/;

/**
 * Classes que posicionam o elemento na grade ("col-span-12 md:col-span-6").
 * Campo com rotulo ocupa a celula pelo invólucro (rotulo + controle); se o col-span
 * ficar so no controle, o invólucro cai numa coluna de 12 e o formulario fica espremido.
 */
export const gridPlacementClasses = (className?: string): string =>
	(className ?? '')
		.split(/\s+/)
		.filter((token) => GRID_PLACEMENT_CLASS.test(token))
		.join(' ');

export default classMerge;
